import { FC } from 'react';

import { TradeButtonsComponent } from './tradeButtons';
import type { TradeActionsProps } from './tradeConfirmation.connect';

export const Component: FC<TradeActionsProps> = ({ enableTrade, onCancel, onTrade, hadTraded }) => {
  if (hadTraded === true) {
    return null;
  }

  return (
    <TradeButtonsComponent
      id="btn-confirm-execute-trade"
      tradeLabelKey="form.buttons.ConfirmToTrade"
      e2e="confirm-trade"
      canTrade={enableTrade}
      onTrade={onTrade}
      onCancel={onCancel}
    />
  );
};

Component.displayName = 'TradeConfirmation';
